import styled from 'styled-components';

import { primitive } from 'styles/constants/primitives';

import { getWidgetSpacing } from '../utils';

export const HeadingContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${primitive.$spacing1};
  margin: 0 0 0 ${getWidgetSpacing.horizontal()};

  ${Styles.desktop`
    margin: 0 0 ${getWidgetSpacing.vertical()};
  `}
`;

export const HeadingText = styled.h1`
  color: ${Styles.color.loyaltyHighlight};
  font-family: ${Styles.fontFamily.brand};
  font-size: 1.375rem;
  text-align: left;
  margin: 0;

  ${Styles.desktop`
    text-align: left;
    font-size: 1.625rem;
  `}
`;

export const NewBadgeContainer = styled.div`
  height: 36px;
  width: 36px;
  path {
    fill: ${Styles.color.black};
  }

  ${Styles.desktop`
    height: 42px;
    width: 42px;
  `}
`;

export const LoadingContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 12rem;
  width: 100%;

  svg {
    fill: ${Styles.color.primary};
  }
`;

export const Container = styled.section`
  padding: ${getWidgetSpacing.vertical()} 0 0;
  background-color: ${Styles.color.background};
  ${Styles.desktop`
    padding: ${getWidgetSpacing.vertical('desktop')} 0;
  `};
`;
